export default {"src":"/_next/static/media/mask-pair-round-left.8c16c9b1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};